import React from "react";

export default function CGU() {
  return (
    <div className="container-x py-16 max-w-3xl mx-auto text-sm leading-relaxed" data-testid="cgu-page">
      <p className="overline text-[#2B8B8E] mb-2">Légal</p>
      <h1 className="text-4xl font-light mb-8">Conditions Générales d'Utilisation</h1>
      <p className="text-xs text-muted-foreground mb-6">Dernière mise à jour : février 2026</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">1. Objet</h2>
      <p>Les présentes CGU régissent l'utilisation du site synergie-workspace.fr et la réservation d'espaces de coworking situés à Vauvert (Gard).</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">2. Éditeur</h2>
      <p>Synergie Workspace — Association loi 1901. Adresse : Vauvert, 30600, Gard. Contact : synergieworkspace@gmail.com — 07 62 36 95 51.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">3. Réservations et paiement</h2>
      <p>Les réservations s'effectuent en ligne et sont réglées par carte bancaire via Stripe. Une confirmation est envoyée après paiement.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">4. Annulation</h2>
      <p>Toute réservation peut être annulée jusqu'à 24 heures avant la date prévue. Passé ce délai, aucun remboursement n'est possible.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">5. Responsabilité</h2>
      <p>Synergie Workspace n'est pas responsable des objets personnels laissés sur place. Le locataire s'engage à respecter les lieux et le règlement intérieur.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">6. Propriété intellectuelle</h2>
      <p>L'ensemble du contenu du site (textes, images, logo) est protégé et ne peut être reproduit sans autorisation.</p>

      <h2 className="text-xl font-semibold mt-8 mb-3">7. Droit applicable</h2>
      <p>Les présentes CGU sont soumises au droit français. Tout litige relève des tribunaux compétents du ressort de Nîmes.</p>

      <p className="mt-10 p-4 bg-[#E0B66A]/10 border border-[#E0B66A]/30 rounded-lg text-xs">
        ⚠️ Ce document est un modèle générique. Nous recommandons de le faire valider par un professionnel du droit avant mise en production définitive.
      </p>
    </div>
  );
}
